export default defineNuxtRouteMiddleware(async (to) => {
  if (to?.fullPath?.includes("undefined")) {
    // undefined links probably due to missing marketSetup config
    console.error("BWF: cannot resolve link ", to.fullPath);
    return abortNavigation();
  }
});
